import styled from "styled-components";

interface NativeDatePickerProps {
  focused: boolean;
  error: string | null;
  direction: "ltr" | "rtl";
}

const NativeDatePicker = styled.input<NativeDatePickerProps>`
  border: none;
  outline: none;
  appearance: none;
  min-height: ${({ theme }) => theme.datePickerMinHeight};
  background: none;
  padding-bottom: 2px;
  font-family: ${(props) => props.theme.fonts.body.family};
  font-size: ${(props) => props.theme.fonts.body.fontSize};
  line-height: ${(props) => props.theme.fonts.body.lineHeight};
  font-weight: ${(props) => props.theme.fonts.body.fontWeight};
  letter-spacing: ${(props) => props.theme.fonts.body.letterSpacing};
  color: ${(props) => props.theme.colors.typographyDefault};
  border-radius: ${(props) => props.theme.borderRadiusInput};
  text-align: ${({ direction }) => (direction === "ltr" ? "left" : "right")};

  box-sizing: border-box;
  padding: ${({ theme }) => theme.paddingSelect};

  ::-webkit-date-and-time-value {
    text-align: ${({ direction }) => (direction === "ltr" ? "left" : "right")};
  }

  border-top: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-left: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-right: ${({ theme, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-bottom: ${({ theme, error, focused }) => {
    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};
`;

export default NativeDatePicker;
